import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

export const useCurrentUser = () => {
  const loggedInUser = useSelector(
    (state: RootState) => state.commonData.loggedInUser
  )

  // Handle roles as array or potentially other formats
  const roles = loggedInUser?.roles || []

  // Check for role presence (case-insensitive for robustness)
  const hasRole = (roleName: string): boolean => {
    if (!Array.isArray(roles)) return false
    return roles.some((r: any) => {
      if (typeof r === 'string') {
        return r.toUpperCase() === roleName.toUpperCase()
      }
      return false
    })
  }

  const isNavigator: boolean = hasRole('NAVIGATOR')
  const isProvider: boolean = hasRole('PROVIDER')

  const currentRole = Array.isArray(roles)
    ? roles.filter((r: any) => r !== 'Everyone').toString()
    : ''

  return {
    currentRole,
    isNavigator,
    isProvider,
  }
}
